import { InvitationTemplateEnum, RoleEnum } from '@sr-sdks/api-sdk-axios';
import { Button, Dialog, DialogProps, Icon } from '@sr/ui-library';
import { useState } from 'react';
import { useActiveWorkspace } from '../hooks/useActiveWorkspace';
import { useCurrentUserAuth } from '../hooks/useCurrentUserAuth';
import {
  userIsWorkspaceAdmin,
  userIsWorkspaceOwner,
} from '../utils/helpers/common';
import { Spinner } from './Loader';
import SendInviteForm from './SendInviteForm';

type SendInviteDialogProps = DialogProps;

const SendInviteDialog = ({
  heading = 'Invite Teammate',
  onOpenChange,
  ...props
}: SendInviteDialogProps) => {
  const [activeWorkspace] = useActiveWorkspace();

  const { currentUser } = useCurrentUserAuth();

  const [isInvitationModalOpen, setIsInvitationModalOpen] = useState(false);

  const canInviteTeammates =
    userIsWorkspaceOwner(currentUser, activeWorkspace?._id ?? '') ||
    userIsWorkspaceAdmin(currentUser, activeWorkspace?._id ?? '');

  return (
    <>
      {canInviteTeammates && (
        <Button
          sectionLeft={<Icon icon="mail" />}
          onClick={() => setIsInvitationModalOpen(true)}
        >
          {heading}
        </Button>
      )}
      <Dialog
        heading={heading}
        className="max-w-screen-md"
        hasActionButton={false}
        hasCancelButton={false}
        open={isInvitationModalOpen}
        onOpenChange={(open) => setIsInvitationModalOpen(open)}
        {...props}
      >
        {!activeWorkspace?._id ? (
          <div className="flex h-full items-center justify-center">
            <Spinner className="mx-auto my-10" size="2" />
          </div>
        ) : (
          <SendInviteForm
            accessLevelDefaultValue={RoleEnum.WorkspaceAdmin}
            invitationType={InvitationTemplateEnum.CustomerInvitation}
            workspace={activeWorkspace}
            onInviteSuccess={() => setIsInvitationModalOpen(false)}
          />
        )}
      </Dialog>
    </>
  );
};

export default SendInviteDialog;
